/**
 * @method relativePath
 * @param path - string representing full route path that needs to be converted to a relative path
 * @param baseRoute - part of the URL that should be replaced to make path relative. Defaults to "/"
 * @returns string representing relative path.
 * @example relativePath('/my/deep/nested/route') returns 'my/deep/nested/route'
 * @example relativePath('/my/deep/nested/route', '/my/deep/') returns 'nested/route'
 */
export const relativePath = (path: string, baseRoute?: string): string => path.replace(baseRoute || '/', '')
